import { Metamodel } from 'app/model/base/model';
import { StoreWriteSettings } from './store-write-settings';
import { AzureDataLakeStoreLinkedService } from 'app/model/linkedservice/azure-data-lake-store.linkedservice';

import { IAttribute, IViolation } from 'app/model/base/annotation';

@Metamodel.model({
    name: 'AzureDataLakeStoreWriteSettings',
    tags: {
        linkedServiceModel: Metamodel.modelFor(AzureDataLakeStoreLinkedService)
    }
})

export class AzureDataLakeStoreWriteSettings extends StoreWriteSettings {
    public static readonly EXPIRY_DATETIME: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'EXPIRY_DATETIME',
        display: stringResources.ModelName_ExpiryDatetime,
        constraint: {
            validator: AzureDataLakeStoreWriteSettings.validateExpiryDatetime
        }
    })
    public expiryDatetime?: string;

    private static validateExpiryDatetime(storeWriteSettings: AzureDataLakeStoreWriteSettings): IViolation[] | undefined {
        const result: IViolation[] = [];
        try {
            if (storeWriteSettings && storeWriteSettings.expiryDatetime != null &&
                !AzureDataLakeStoreWriteSettings.EXPIRY_DATETIME.templateValue(storeWriteSettings)) {
                    const currentTime = new Date();
                    if (Date.parse(storeWriteSettings.expiryDatetime) < currentTime.getTime()) {
                        result.push(
                            {
                                context: storeWriteSettings.expiryDatetime,
                                message: () => stringResources.AzureDataLakeStoreWriteSettings_ExpiryDateTimeError
                            }
                        );
                    }
            }
        } catch {
            // do nothing
        }
        return result;
    }
}
